module.exports = __webpack_public_path__ + "img/Deck V2.ed1734f4.jpg";